// カテゴリ変更時の「入力内容を保持しますか？」確認モーダル（CategoryTemplateConfirmModal 島）を
// JS から命令的に開くためのブリッジ。
//
// COMMUNITY_MODAL.md の標準形は「トリガー要素の click を document 委譲で拾う」だが、
// 本件は要素クリックではなく <select> の change から開くため CustomEvent 方式にしている。
//
// 島がマウントされていないページ（レイアウトにマウント行が無い等）では誰も event を受け取らない。
// その場合は安全側に倒して 'keep'（本文を保持し、テンプレートを適用しない）を返す。
// 島は受け取ったことを event.preventDefault() で知らせる。

export const CATEGORY_TEMPLATE_CONFIRM_EVENT = 'coorum:category-template-confirm';

/** 保持 / テンプレート適用 / カテゴリ変更自体のキャンセル */
export type CategoryTemplateConfirmChoice = 'keep' | 'apply' | 'cancel';

export type CategoryTemplateConfirmRequest = {
  resolve: (choice: CategoryTemplateConfirmChoice) => void;
};

/** 確認モーダルを開き、ユーザーの選択が決まったら resolve する。 */
export function confirmCategoryTemplate(): Promise<CategoryTemplateConfirmChoice> {
  return new Promise((resolve) => {
    let settled = false;
    const settleOnce = (choice: CategoryTemplateConfirmChoice) => {
      if (settled) return;
      settled = true;
      resolve(choice);
    };

    const event = new CustomEvent<CategoryTemplateConfirmRequest>(
      CATEGORY_TEMPLATE_CONFIRM_EVENT,
      { detail: { resolve: settleOnce }, cancelable: true },
    );

    // dispatchEvent は preventDefault されると false を返す。島が受け取れなかった場合は保持で確定する。
    const acceptedByModal = !document.dispatchEvent(event);
    if (!acceptedByModal) settleOnce('keep');
  });
}
